class OrderLog_mok {
  static getorderLog(editorder) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          detail: {
            id: "1",
            name: "آرش فکری",
            status: "در انتظار برسی",
            orderNumber: "1452456987",
            orderdate: "22 خرداد 1402 - 23:54",

            reciver: "آرش فکری",
            phoneNumber: "09215863622",
            postalcode: "145592456987",
            city: "فارس - شیراز",
            address:
              "آدرس:  خیابان ستارخان، بن بست 21، فرعی 3، ساختمان هیبا، طبقه دوم، واحد 4 ",
            totalAmount: "7،035،000 تومان",
            paymentMethod: "پرداخت اینترنتی",
            transactionNumber: "1452452446987",
            Amount: "7،000،000 تومان",
            deliverycost: "35،000 تومان",
            deliverycode: "1453645768562456987",
          },
          OrderTable_data: [
            {
              id: 1,
              productName: "دستگاه دما رطوبت مدل صنعتی A12",
              number: "تعداد انتخاب",
              amount: "3،500،00 تومان",
              cost: "7،000،000 تومان",
            },
          ],
        });
      }, 1000);
    });
  }
  static deleteorder(id) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          status: {
            code: "1",
            massage: "سفارش حذف شد",
          },
        });
      }, 1000);
    });
  }
  static product(text) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          products: [ { value: "دستگاه دما رطوبت مدل صنعتی A12", label: "دستگاه دما رطوبت مدل صنعتی A12" },
          { value: "دستگاه دما رطوبت مدل صنعتی ویاک", label: "دستگاه دما رطوبت مدل صنعتی ویاک" },
          { value: "دستگاه دما رطوبت مدل صنعتی B334", label: "دستگاه دما رطوبت مدل صنعتی B334" },
          { value: "دستگاه دما رطوبت مدل صنعتی D4", label: "دستگاه دما رطوبت مدل صنعتی D4" },
          { value: "دستگاه دما رطوبت مدل صنعتی D5", label: "دستگاه دما رطوبت مدل صنعتی D4" },],
          productAmount:[
            { name: "دستگاه دما رطوبت مدل صنعتی A12",  amount: "550000 "},
            { name: "دستگاه دما رطوبت مدل صنعتی ویاک", amount: "700000 "},
            { name: "دستگاه دما رطوبت مدل صنعتی B334", amount: "500000 "},
            { name: "دستگاه دما رطوبت مدل صنعتی D4",   amount: "300000 "},
            { name: "دستگاه دما رطوبت مدل صنعتی D5",   amount: "120000 "},
          ]
        });
      }, 1000);
    });
  }
}
export { OrderLog_mok };
